import SearchForm from "../searchForm/searchForm";
import InnerPageBanner from "../../../shared/components/innerPageBanner/innerPageBanner";
import ProductItem from "../../../shared/components/productItem/productItem";
import "./searchResult2.css";
import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { useLocation } from "react-router-dom";
import Pagination from "rc-pagination";
import "rc-pagination/assets/index.css";
import { useEffect, useState } from "react";
import "../../../shared/components/pagination/pagination.css";
import Backdrop from '@mui/material/Backdrop';
import SyncLoader from "react-spinners/SyncLoader";
import { css } from "@emotion/react";
import Select from 'react-select';

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const sortOptions = [
    { value: 'sortby', label: 'Sort By' },
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
    { value: 'h-to-l', label: 'Highest to Lowest price' },
    { value: 'l-to-h', label: 'Lowest to Highest price' },
    { value: 'alphabet', label: 'Alphabets' },
];

const SearchResult = () => {

    const [option1, setOption1] = useState({ value: 'Sortby', label: 'Sort By' })


    const handleChange1 = (selectedOption) => {
        setOption1(selectedOption);
        console.log(`Option selected:`, selectedOption);
    };

    let query = useQuery();
    const title = query.get("title");
    const categoryId = query.get("categoryId");
    const subCategoryId = query.get("subCategoryId");
    const location = query.get("location");
    const distance = query.get("distance");
    const marketFilter = query.get("marketFilter");
    const [sort, setSort] = useState(query.get("sort"));
    const lng = query.get("lng");
    const lat = query.get("lat");
    const [open, setOpen] = useState(true);

    const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
  `;

    // const { title, categoryId, subCategoryId, location, distance } = useParams();
    const docsPerPage = 6;
    const [pageNumber, setPageNumber] = useState(1);

    const filteredProducts = useSelector(state => state.filteredProducts);
    console.log("filteredProducts are: ", filteredProducts);

    const handlePageChange = (current, pageSize) => {
        setPageNumber(current);
    };

    return (
        <>
            <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}>
                <SyncLoader color={"#ff7e06"} loading={true} css={override} size={11} />
            </Backdrop>
            <InnerPageBanner />
            <SearchForm title={title} categoryId={categoryId} subCategoryId={subCategoryId} location={location} lat={lat} lng={lng} distance={distance} marketFilter={marketFilter} sort={sort} setSort={setSort} filteredProducts={filteredProducts} docsPerPage={docsPerPage} pageNumber={pageNumber} setPageNumber={setPageNumber} setOpen={setOpen} />
            <section className="product-listing-wrapper inner-page-product-listing">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12">
                            <div className="product-head-wrap d-flex flex-row align-items-center justify-content-between">
                                <div className="sort-tag">
                                    <h1>search result</h1>
                                </div>
                                <select id="sort-by" name="sort-by" className="field-des" onChange={(event) => {
                                    const value = event.target.value;
                                    setSort(value !== "sort-by" ? value : null);
                                }}>
                                    <option value="sort-by" selected={!sort ? true : false}>Sort By</option>
                                    <option value="newest" selected={sort === "newest" ? true : false}>Newest</option>
                                    <option value="oldest" selected={sort === "oldest" ? true : false}>Oldest</option>
                                    <option value="highest-to-lowest-price" selected={sort === "highest-to-lowest-price" ? true : false}>Highest to lowest price</option>
                                    <option value="lowest-to-highest-price" selected={sort === "lowest-to-highest-price" ? true : false}>Lowest to highest price</option>
                                    <option value="alphabetical" selected={sort === "alphabetical" ? true : false}>Alphabetical</option>
                                </select>
                                {/* <Select id="color"
										value={option1}
										onChange={() => handleChange1()}
										classNamePrefix="sort-select"
										options={sortOptions}
									/> */}
                            </div>
                        </div>
                        {filteredProducts && filteredProducts.pageNumber === pageNumber && filteredProducts.list.map((product, index) => {

                            var img = `${process.env.REACT_APP_URL}/static/images/sample-img.jpg`;
                            if (product.images.length != 0) {
                                img = `${process.env.REACT_APP_SERVER_URL}/images/${product.images[0]}`;
                            }
                            return (
                                <div className="col-lg-4 col-md-6 col-sm-6 col-xs-6 my-2" key={index}>
                                    <ProductItem id={product._id} path={img} title={product.title} location={product.location} price={product.buyNowPrice} />
                                </div>
                            );
                        })}
                        <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 mt-5">
                            <div className="product-pagination">
                                <Pagination
                                    className="pagination"
                                    defaultPageSize={docsPerPage}
                                    pageSize={docsPerPage}
                                    current={pageNumber}
                                    total={filteredProducts.unSkippedSize && filteredProducts.unSkippedSize}
                                    onChange={handlePageChange}
                                    hideOnSinglePage
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default SearchResult;